import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* Fixed Header */}
        <header className="App-header">
          <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="logo-text" style={{ textDecoration: 'none', cursor: 'pointer' }}>
            Aura
          </a>
          <nav className="nav-actions">
            <a href="#our-story" className="body-small hover:text-text-secondary transition-colors">
              Our Story
            </a>
            <a href="#product" className="body-small hover:text-text-secondary transition-colors">
              Product
            </a>
            <a href="#pricing-model" className="body-small hover:text-text-secondary transition-colors">
              Pricing Model
            </a>
          </nav>
        </header>

        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
